import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../../components/common/Typography';
import SlideRightDialog from '../../components/common/SlideRightDialog';
import Button from '../../components/common/Button';

const Description = ({ isOpen, onClose, title, description, handleSubCheckboxChange2 }) => {
  const { t } = useTranslation('terms');
  const { t: tCommon } = useTranslation('common');

  // 개인정보 위탁처리 테이블 헤더 (terms1용)
  // tableHeader: 수탁 업체, 위탁 업무, 위탁 정보
  const tableHeader = t('terms1.tableHeader', { returnObjects: true });

  // 개인정보 위탁처리 테이블 데이터 (terms1용)
  // trusteeTableData: 인포뱅크(문자메시지 발송), 더화이트커뮤니케이션(전화 상담 시스템), 휴머스온(알림톡 발송)
  const trusteeTableData = t('terms1.trusteeTableData', { returnObjects: true });

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
  };

  const thStyle = {
    width: '33.33%',
    backgroundColor: 'var(--GrayScale-100)',
    padding: '10px 8px',
    borderBottom: '1px solid var(--GrayScale-300)',
    textAlign: 'center',
    color: 'var(--GrayScale-700)',
  };

  const tdStyle = {
    width: '33.33%',
    padding: '10px 8px',
    border: 'none',
    borderBottom: '1px solid var(--GrayScale-200)',
    textAlign: 'center',
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose} title={tCommon('header.title13')}>
      <div className="displayFlexColumn" style={{ gap: '10px', paddingBottom: '70px' }}>
        <Typography className="body1Bold">{title}</Typography>
        <Typography className="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
          {description}
        </Typography>
        {isOpen === 1 && Array.isArray(trusteeTableData) && (
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle} className="captionBold">
                  {tableHeader?.company}
                </th>
                <th style={thStyle} className="captionBold">
                  {tableHeader?.task}
                </th>
                <th style={thStyle} className="captionBold">
                  {tableHeader?.info}
                </th>
              </tr>
            </thead>
            <tbody>
              {trusteeTableData.map((row, index) => (
                <tr key={index}>
                  <td style={tdStyle} className="captionMedium">
                    {row.company}
                  </td>
                  <td style={tdStyle} className="captionMedium">
                    {row.task}
                  </td>
                  <td style={tdStyle} className="captionMedium">
                    {row.info}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="button_container">
        <Button value={t('button2')} fullWidth onClick={() => handleSubCheckboxChange2(isOpen)} />
      </div>
    </SlideRightDialog>
  );
};

export default Description;
